import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Icon, Menu, Ref } from 'semantic-ui-react'
import EventsStore from '../../stores/EventsStore'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

@inject('eventsStore')
@withRouter
@observer
class MenuEvent extends Component {
  static propTypes = {
    eventsStore: PropTypes.instanceOf(EventsStore),
    isReview: PropTypes.bool,
    location: PropTypes.object,
    history: PropTypes.object,
    readOnly: PropTypes.bool
  }

  static defaultProps = {
    isReview: false,
    readOnly: false
  }

  state = {
    showSummary: false
  }

  constructor (props) {
    super(props)
    this.tabRef = React.createRef()
  }

  componentDidMount () {
    const { isReview, eventsStore, location } = this.props
    const searchParams = new URLSearchParams(location.search)
    if (isReview && searchParams.get('view') === 'summary') {
      this.setState({ showSummary: isReview }, () => {
        if (isReview) {
          eventsStore.changeCurrentForm('summary')
        }
      })
      return
    }
    if (searchParams.has('formcode')) {
      eventsStore.changeCurrentForm(searchParams.get('formcode'))
    }
  }

  handleSummaryClick = (e, data) => {
    const { eventsStore, location, history } = this.props
    eventsStore.changeCurrentForm(data.value)
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('view', 'summary')
    searchParams.delete('formcode')
    history.push({
      pathname: location.pathname,
      search: searchParams.toString()
    })
    this.setState({ showSummary: true })
  }

  handleItemClick = (e, data) => {
    const { eventsStore, location, history } = this.props
    eventsStore.changeCurrentForm(data.value)
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('formcode', eventsStore.currentForm.code)
    searchParams.delete('view')
    history.push({
      pathname: location.pathname,
      search: searchParams.toString()
    })
    this.setState({ showSummary: false })
  }

  handleAddEquipment = () => {
    const { eventsStore } = this.props
    eventsStore.createEquipment()
    eventsStore.setEquipmentPage(eventsStore.allEquipmentsFromCurrentForm.length)
  }

  handleDeleteEquipment = () => {
    const { eventsStore } = this.props
    if (eventsStore.currentEquipment) {
      eventsStore.deleteEquipment(eventsStore.currentEquipment)
    }
  }

  handleSave = () => {
    const { eventsStore } = this.props
    eventsStore.saveForms()
  }

  handleValidate = () => {
    const { eventsStore } = this.props
    eventsStore.validateForms(true)
    eventsStore.generateNFPA()
  }

  handleSubmit = () => {
    const { eventsStore, history } = this.props
    eventsStore.validateForms()
    eventsStore.generateNFPA()
    if (eventsStore.equipmentWithErrors.size) {
      console.log('we had errors cannot continue')
      return
    }
    // eventsStore.generateNFPA()
    eventsStore.saveForms().then(() => {
      // go to submission page
      history.push({
        pathname: `/events/submit/${eventsStore.event.id}`
      })
    })
  }

  handleChangeShowAllEquipment = () => {
    this.props.eventsStore.showAllEquipments(!this.props.eventsStore.showAllEquipment)
  }

  handleDownloadClick = (eventId) => {
    const { eventsStore } = this.props
    eventsStore.download(eventId)
  }

  handleImportLastEvent = () => {
    const { eventsStore } = this.props
    eventsStore.importLastEvent(eventsStore.event.id, eventsStore.currentForm.code).then(() => {
      eventsStore.loadFormEvent(eventsStore.event.id, eventsStore.currentForm.code)
    })
  }

  render () {
    const { eventsStore, isReview, readOnly } = this.props
    const { showSummary } = this.state
    return (
      <Ref innerRef={this.tabRef}>
        <>
          <Menu tabular>
            <Menu.Menu>
              {isReview && <Menu.Item
                key='view'
                value='summary'
                name='Sommaire'
                active={showSummary}
                onClick={this.handleSummaryClick}
                           />}
              {eventsStore.forms.map(form => {
                let hasError = false
                for (const formEntry of eventsStore.equipmentWithErrors.values()) {
                  if (formEntry.form_id === form.id) {
                    hasError = true
                    break
                  }
                }
                return (
                  <Menu.Item
                    key={form.code}
                    value={form.code}
                    name={form.name}
                    className={hasError ? 'error' : undefined}
                    active={eventsStore.currentForm && eventsStore.currentForm.code === form.code}
                    onClick={this.handleItemClick}
                  />
                )
              })}
            </Menu.Menu>
            {!readOnly &&
              <Dropdown item text='Options' pointing='top right' floating>
                <Dropdown.Menu>
                  {!showSummary &&
                    <>
                      {eventsStore.menuEquipment.enableShowAll &&
                        <Dropdown.Item onClick={this.handleChangeShowAllEquipment}><Icon name='list' />
                          {!eventsStore.showAllEquipment && <>Afficher tous les équipements</>}
                          {eventsStore.showAllEquipment && <>Afficher par équipement</>}
                        </Dropdown.Item>}
                      <Dropdown.Item onClick={this.handleAddEquipment}>
                        <Icon
                          name='plus'
                        />Équipement
                      </Dropdown.Item>
                      <Dropdown.Item onClick={this.handleDeleteEquipment} disabled={(eventsStore.equipmentCount <= 1)}>
                        <Icon
                          name='trash'
                        />Équipement
                      </Dropdown.Item>
                    </>}
                  <Dropdown.Item onClick={this.handleSave}><Icon name='save' />Enregistrer</Dropdown.Item>
                  <Dropdown.Item onClick={this.handleValidate}><Icon name='check' />Valider Formulaires</Dropdown.Item>
                  {!isReview && <Dropdown.Item onClick={this.handleSubmit}><Icon name='send' />Soumettre</Dropdown.Item>}
                  {!isReview &&
                    <Dropdown.Item disabled={!eventsStore.currentForm} onClick={this.handleImportLastEvent}><Icon name='arrow right' />Importer
                      dernière inspection
                    </Dropdown.Item>}
                </Dropdown.Menu>
              </Dropdown>}
            {readOnly &&
              <Dropdown item text='Options' pointing='top right'>
                <Dropdown.Menu>
                  {eventsStore.menuEquipment.enableShowAll &&
                    <Dropdown.Item onClick={this.handleChangeShowAllEquipment}><Icon name='list' />
                      {!eventsStore.showAllEquipment && <>Afficher tous les équipements</>}
                      {eventsStore.showAllEquipment && <>Afficher par équipement</>}
                    </Dropdown.Item>}
                  <Dropdown.Item as='a' target='_blank' href={`/api/archives/downloadpdf/${eventsStore.event.id}`}><Icon name='certificate' />Télécharger Certificat</Dropdown.Item>
                  <Dropdown.Item disabled={eventsStore.isDownloading} onClick={() => { this.handleDownloadClick(eventsStore.event.id) }}>
                    <Icon name={eventsStore.isDownloading ? 'spinner' : 'download'} loading={eventsStore.isDownloading} />
                    {eventsStore.isDownloading ? 'Téléchargement en cours...' : 'Télécharger Rapport'}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>}
          </Menu>

        </>
      </Ref>
    )
  }
}

export default MenuEvent
